export default __webpack_public_path__ + "static/media/ygg_banner.5328b323.png";